<template>
    <Dialog :dialog="dlg">
        
        <FileDrop :isLoading="dlg.isUploading" @filesSelected="(a,b,c,d) => dlg.onFilesSelected(a,b,c,d)">

        </FileDrop>


    </Dialog>
</template>



<script setup>
////////////////////////////////////////////////////////////////////////////////////////////////////
//
// Usage:  
// MODEL CODE: 
//     async uploadWorkorderAttachment(formData) {
//         this.isLoading = true;
//         try {
//             formData.append("id_workorder", this.id);
//             var result = await api.uploadWorkorderAttachment(formData);
//             if (result && result.data) {
//                 this.attachments = result.data.attachments || [];
//             }
//         } finally {
//             this.isLoading = false;
//         }
//     }
// 
//     var fnUpload = async function(formData) {
//         await model.uploadWorkorderAttachment(formData);
//     };
//     dlg.upload({fnUpload: fnUpload})
// 
// 
//
////////////////////////////////////////////////////////////////////////////////////////////////////



    import FileDrop from '@controls/file/FileDrop'
    import Dialog from '@shared/ui/dialogs/ActionDialog'
    import Constants from '@app/consts'
    import eventbus from '@app/eventbus'
    import { attachments as api } from '@app/api'

    import compress from '@lib/compress';

    import { ref } from 'vue'
    import clsDialog from '@cls/clsDialog'

    class clsUploadDialog extends clsDialog {
        msg = ""
        isUploading = false;
        fnUpload = null;        
        async closeDialog(force) {
            super.closeDialog(true);
        }

        onOpen(params) {
            this.fnUpload = params.fnUpload;
            if (!this.fnUpload) {
                throw new Error("clsUploadDialog.onOpen: fnUpload is required");
            }
            return super.onOpen(params);            
        }

        async onFilesSelected(fileList) {

            if (!fileList || !fileList.length) {
                return; // Just ignore.
            }

            let cnt = fileList.length;
            if (cnt > 4) {
                eventbus.dialog.alert({
                    title: "Te veel bestanden",
                    body:  "U kunt maximaal 4 bestanden tegelijk uploaden."});
                return;
            }

            let formData = new FormData();
            for (var n = 0; n < fileList.length; n++) {
                let originalFile = fileList[n];

                let file = await compress.try(originalFile); 
                if (!file) {
                    return; // Error. Stop processing.
                }

                if (file.size > Constants.limits.file_upload.bytes) {
                    eventbus.dialog.alert({
                        title: "Te groot bestand",
                        body:  `De maximale bestandsgrootte is ${Constants.limits.file_upload.text}.`});
                    return;
                }
                formData.append(`file${n}`, file);
            }

            this.msg = `Bezig ${cnt} bestand${cnt==1?"":"en"} te uploaden`;
            this.isUploading = true;

            let self = this;
            
            try {
                var result = await this.fnUpload(formData);
                let count = result && Number(result?.data?.count) || 0;
                
                if (this.fnResolve) {
                    this.fnResolve({count: count});
                }
                self.open = false;

                self.closeDialog();
            }
            finally {
                self.isUploading = false;
            }
        }

    }

    // let model = useModel();
    let dlg = ref(
        new clsUploadDialog("document_upload", "Upload bestanden", null, null, {
            save: null,
            icon: 'upload'
        })).value;


    window.dlgupload = dlg;


</script>
